module.exports = __webpack_public_path__ + "static/media/background-image.2b7a8022.jpg";